export function formatPropertyKeyFormatCheck() {
  return "record property key must be valid";
}
